export default __webpack_public_path__ + "static/media/cloud-upload-o.1a4c77cc.svg";